import axios from 'axios';


const getBaseUrl = () => {
    return process.env.REACT_APP_HOST_URL;
}

console.log("BASE_URL:", getBaseUrl());


export const getFacilities = async (page = 1, limit = 10, filters = {}) => {
    try {
        const response = await axios.get(`${getBaseUrl()}/facilities`, {
            params: { page, limit, ...filters }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching facilities:', error);
        return { data: [], pagination: {} };
    }
};

export const addFacility = async (facilityDataWithUser) => {
    try {
        return await axios.post(`${getBaseUrl()}/addfacilities`, facilityDataWithUser);
    } catch (error) {
        console.error("Error while adding facility");
        throw error;
    }
};

export const getSlicOptions = async () => {
    try {
        const response = await axios.get(`${getBaseUrl()}/facilities/filters/slic`);
        return response.data;
    } catch (error) {
        console.error("Error fetching SLIC options:", error);
        throw error;
    }
};

export const getCenterOptions = async () => {
    try {
        const response = await axios.get(`${getBaseUrl()}/facilities/filters/center`);
        return response.data;
    } catch (error) {
        console.error("Error fetching Center options:", error);
        throw error;
    }
};

export const getUldTypeOptions = async () => {
    try {
        const response = await axios.get(`${getBaseUrl()}/facilities/filters/uldType`);
        return response.data;
    } catch (error) {
        console.error("Error fetching ULD Type options:", error);
        throw error;
    }
};

export const getSiteOptions = async () => {
    try {
        const response = await axios.get(`${getBaseUrl()}/facilities/filters/site`);
        return response.data;
    } catch (error) {
        console.error("Error fetching Site options:", error);
        throw error;
    }
};
